/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

export const notSharedAction = [
  "private",
  "ActiveUser",
  "ActiveRoom",
  "setConfiguredStunServer",
  "updateActiveRooms",
  "PendingRequest",
  "setMyJoiningRequest",
  "Invitation",
  "updateMute",
  "initializeUser",
  "iAmRoomOwner",
  "updateUser",
  "addNewJoiner",
  "setParticipants",
  "participantMovement",
  "updatePlayerHands",
  "setLocalStream",
  "setRemoteStreams",
  "isAudioOnly",
  "updateRoomData",
  "loadRemote",
]